const planCategory = () => import("@/pages/plan/category/index.vue");

export default [
    {
        path: "/plan/category",
        component: planCategory,
        meta: [
            {
                name: "方案管理",
                activeRoute: "/plan/manage",
            },
            {
                name: "方案分类",
                activeRoute: "/plan/category",
            },
        ],
    }
];
